<template>
  <v-layout wrap v-if="akses">
    <v-flex xs12 class="pa-5">
      <v-alert class="body-2 mb-5" dense text type="info">
        Silakan pilih peran yang akan diubah kemudian Anda dapat melanjutkan
        mengatur aksesnya.
      </v-alert>
      <m-card title="Detail Akses">
        <v-layout wrap>
          <v-flex>
            <v-list>
              <div class="my-4 mx-2">
                <label>Peran</label>
                <v-select
                  v-model="peran"
                  :items="itemRoles"
                  item-text="name"
                  item-value="id"
                  placeholder="Pilih Peran"
                  outlined
                  dense
                  @change="loadAkses"
                />
              </div>
              <div v-if="akses" class="mt-5">
                <v-subheader class="title black--text mt-5 mb-2"
                  >Akses yang diseting</v-subheader
                >
                <div>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Akses
                          </th>
                          <th class="text-left">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in akses.permissions" :key="i">
                          <td>{{ item.label || item.name || "" }}</td>
                          <td>
                            <v-checkbox readonly v-model="form[item.id]" />
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </div>
            </v-list>
          </v-flex>
        </v-layout>
      </m-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      akses: [],
      itemRoles: [],
      form: {},
      peran: null
    };
  },
  computed: {
    id() {
      return this.$route.params.tenant_id || 0;
    }
  },

  mounted() {
    this.loadRoles();
  },

  methods: {
    loadRoles() {
      const params = {
        tenant_id: this.id
      };

      this.$store.dispatch("akses/getRoles", params).then(resp => {
        this.itemRoles = (resp && resp.data) || [];
      });
    },

    loadAkses() {
      const params = {
        tenant_id: this.id,
        role_id: this.peran
      };

      this.$store.dispatch("akses/get", params).then(res => {
        this.akses = (res && res.data) || [];

        const { role_permissions, permissions } = res && res.data;

        permissions.forEach(key => {
          const find =
            role_permissions.find(s => s.permission_id === key.id) || {};
          this.$set(
            this.form,
            key.id,
            Object.keys(find).length ? Number(find["is_aktif"]) : 0
          );
        });
      });
    },

    close() {
      this.$router.push({
        name: "akses"
      });
    }
  }
};
</script>
